<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.voucherList.push"
    :is-show-student-select="true"
    :is-show-store-select="true"
    :is-multiple-store="true"
    :has-private-store="true"
    :is-show-limit-store-select="true"
    :is-multiple-limit-store="true"
    :has-private-limit-store="true"
    store-select-label="归属门店"
    limit-store-select-label="限制使用门店"
    student-select-label="所属学员"
    :show-summary="true"
  >
    <template slot="header-item">
      <div class="flex-align-center flex-wrap table-filter-item">
        <div class="flex-align-center table-filter-label">代金券类型：</div>
        <v-select-voucher-type
          v-model="queryList.voucher_type_ids"
          :multiple="true"
          :is-filter="true"
          :issue-types="[]"
          size="small"
          placeholder="输入名称搜索"
          @change="handleTypeChange"
        />
      </div>

      <v-select-voucher-status
        v-model="queryList.voucher_status"
        label="状态"
        size="small"
        clearable
        @change="handleStatusChange"
      />
    </template>
    <v-column-time/>
    <v-column-time value="过期时间" field="expire_time" time-format="timeToYmdHi" empty-tip="-" sortable=""/>

    <el-table-column label="归属门店">
      <template v-slot="{ row }">
        <span :class="{ 'info-color': !row.store_id }">{{ row.store_name }}</span>
        <div v-if="row.store_id" class="info-color">{{ row.store_source_name }}</div>
        <div v-else-if="row.is_app" class="info-color">用券办卡后自动归属</div>
      </template>
    </el-table-column>
    <el-table-column label="限制使用门店">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_store_limited" size="small" type="warning">{{ row.limit_store_name }}</el-tag>
        <span v-else class="info-color">全部门店</span>
      </template>
    </el-table-column>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="代金券类型" prop="voucher_type_name"/>
    <el-table-column label="面额（元）">
      <template v-slot="{ row }">{{ row.amount_in_cents | toYuan }}</template>
    </el-table-column>
    <el-table-column label="发放方式">
      <template v-slot="{ row }">
        <span v-for="state in findVoucherIssueType(row.issue_type)" :key="state.value">
          {{ state.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="唯一性（发放时）">
      <template v-slot="{ row }">{{ row.is_unique === 1 ? '每人限领一张' : '可重复拥有' }}</template>
    </el-table-column>
    <el-table-column label="使用规则" prop="rule" show-overflow-tooltip />
    <el-table-column label="状态">
      <template v-slot="{ row }">
        <el-tag v-if="row.use_time" type="info" size="small">已使用</el-tag>
        <el-tag v-else-if="row.is_expired" type="danger" size="small">已过期</el-tag>
        <el-tag v-else type="success" size="small">可用</el-tag>
      </template>
    </el-table-column>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.voucherDetail.to(row.id)" name="查看" icon="view"/>

        <v-list-button
          v-if="isAdministrator"
          name="退券"
          icon="bin"
          :to="RouteConfig.voucherDelete.to(row.id)"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`voucher-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>归属门店</span>
              <span :class="{ 'info-color': !v.store_id }">{{ v.store_name }}</span>
            </div>

            <div v-if="v.is_app || v.store_id" class="list-item-detail">
              <span>归属依据</span>
              <span>{{ v.store_id ? v.store_source_name : '用券办卡后自动归属' }}</span>
            </div>

            <div class="list-item-detail">
              <span>限制使用门店</span>
              <span>{{ v.limit_store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属学员</span>
              <span>{{ v.student_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>代金券类型</span>
              <span>{{ v.voucher_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>面额（元）</span>
              <span>{{ v.amount_in_cents | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>发放方式</span>
              <span v-for="state in findVoucherIssueType(v.issue_type)" :key="state.value">
                {{ state.name }}
              </span>
            </div>

            <div class="list-item-detail">
              <span>唯一性（发放时）</span>
              <span>{{ v.is_unique === 1 ? '每人限领一张' : '可重复拥有' }}</span>
            </div>

            <div class="list-item-detail">
              <span>过期时间</span>
              <span>{{ v.expire_time | timeToYmdHi('永久有效') }}</span>
            </div>

            <div class="list-item-detail">
              <span>状态</span>
              <span>
                <el-tag v-if="v.use_time" type="info" size="small">已使用</el-tag>
                <el-tag v-else-if="v.is_expired" type="danger" size="small">已过期</el-tag>
                <el-tag v-else type="success" size="small">可用</el-tag>
              </span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.voucherDetail.to(v.id)" name="查看" icon="view"/>

              <v-list-button
                v-if="isAdministrator"
                name="退券"
                icon="bin"
                :to="RouteConfig.voucherDelete.to(v.id)"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/voucher';
import { findVoucherIssueType } from '@/enums/voucherIssueTypes';
import { voucherStatuses } from '@/enums/voucherStatuses';

export default {
  name: RouteConfig.voucherList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      student_ids: [],
      store_ids: [],
      limit_store_ids: [],
      voucher_type_ids: [],
      voucher_status: 0,
      is_del: 0,
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'defaultStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findVoucherIssueType,
    handleStatusChange(value) {
      this.queryList.page = 1;
      this.queryList.voucher_status = value || 0;
      RouteConfig.voucherList.push({ ...this.queryList });
    },
    handleTypeChange(value) {
      this.queryList.voucher_type_ids = value || [];
      this.queryList.page = 1;
      RouteConfig.voucherList.push({ ...this.queryList });
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      if (!this.isAdministrator) {
          queryList.limit_store_ids = [this.defaultStoreId];
          queryList.voucher_status = voucherStatuses.available.value;
        } else {
          queryList.limit_store_ids = [];
          queryList.voucher_status = 0;
        }
        queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, query);

      const params = { ...queryList };
      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
